import { useSyncExternalStore } from 'react';
import { useLocation } from 'react-router-dom';
import * as RemoteEmergency from '../services/RemoteEmergency';

/**
 * Loopt er een noodoproep op deze tablet? Dan mag geen enkele standby-laag (screensaver,
 * slaapstand, gedimde verlichting) het scherm afdekken.
 *
 * Twee bronnen, omdat een noodoproep op twee manieren begint:
 *   - de automation zet de tablet in alarmmodus (`emergency`/`alarm_mode`-commando), ook
 *     als het alarm van een ander toestel in de unit komt en niemand deze tablet aanraakte;
 *   - de bewoner drukt zelf op de noodknop en staat op /emergency (bevestigen, verzonden).
 *
 * Voorheen lagen slaapstand en screensaver in de z-volgorde bóven de noodpagina en werden
 * ze pas weggehaald door een inkomende oproep: tijdens het aftellen zag de bewoner niets.
 */
export function useEmergencyActive(): boolean {
  const remote = useSyncExternalStore(RemoteEmergency.subscribe, RemoteEmergency.getState);
  const { pathname } = useLocation();
  return remote.active || pathname === '/emergency';
}
